import { render, staticRenderFns } from "./LoadingUI.vue?vue&type=template&id=53accad0&scoped=true"
import script from "./LoadingUI.vue?vue&type=script&lang=js"
export * from "./LoadingUI.vue?vue&type=script&lang=js"
import style0 from "./LoadingUI.vue?vue&type=style&index=0&id=53accad0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53accad0",
  null
  
)

export default component.exports